import clsx from "clsx";
import { ReactNode } from "react";
import "./DualButton.scss";

export type DualButtonProps = {
  buttonLeft: ReactNode;
  buttonRight: ReactNode;
  gap?: boolean;
  onClick?: () => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
};

/**
 * Pass in two instantiated MDS buttons to create a dual button.
 */
export const DualButton = ({
  ref,
  buttonLeft,
  buttonRight,
  onClick,
  onKeyDown,
  gap = false,
}: DualButtonProps & { ref?: React.Ref<HTMLDivElement> }) => {
  return (
    <div
      className={clsx("dual-button flex", gap && "gap-[1px]")}
      ref={ref}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <span className="dual-button-left">{buttonLeft}</span>
      <span className="dual-button-right">{buttonRight}</span>
    </div>
  );
};

DualButton.displayName = "DualButton";
